import React, { useState } from 'react';
import styled from 'styled-components';

// Definindo a interface para as props do componente
interface MonetaryInputProps {
  value: number;
  onChange: (value: number) => void;
  placeholder?: string;
  disabled?: boolean
}

// Estilizando o input
const Input = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #0066cc;
  }
`;

export const MonetaryInput = ({ value, onChange, placeholder, disabled }: MonetaryInputProps) => {
  const [displayValue, setDisplayValue] = useState<string>(value.toFixed(2));

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = event.target.value.replace(/[^0-9]/g, '');
    const numericValue = parseFloat(rawValue) / 100;
    setDisplayValue(formatCurrency(numericValue));
    onChange(numericValue);
  };

  const formatCurrency = (value: number): string => {
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  return (
    <Input
      type="text"
      value={displayValue}
      onChange={handleChange}
      placeholder={placeholder}
      disabled={disabled}
    />
  );
};